// Add new brand IDs here to render them with the DA (Da*) screens.
export const DA_BRAND_IDS = ["wlms", "axepta"];

export const isDaBrand = (tenant, brandId) => tenant === "ms1" && DA_BRAND_IDS.includes(brandId?.toLowerCase());
